(function () {
  'use strict';

  var productMatch = window.location.pathname.match(/\/products\/([^/]+)/);

  if (!productMatch) return;

  var productHandle = productMatch[1];

  var wrapperId = 'rsi_form_wrapper';
  var submitSelector = '[data-rsi-cod-button="true"]';
  var fieldSelector =
    'input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), select, textarea';
  var originalPage = window.location.pathname;
  var wrapper = null;
  var formWasOpen = false;
  var formStarted = false;
  var submitTracked = false;
  var wrapperObserver = null;

  function trackStep(step) {
    window._uxa = window._uxa || [];
    window._uxa.push([
      'trackPageview',
      '/csq/cod/' + step + '/' + productHandle,
      { lifespan: 'onNextPageviewOnly' }
    ]);
  }

  function restoreProductPageview() {
    window._uxa = window._uxa || [];
    window._uxa.push([
      'trackPageview',
      originalPage,
      { lifespan: 'onNextPageviewOnly' }
    ]);
  }

  function isFormOpen() {
    if (!wrapper) return false;

    return Boolean(
      wrapper.matches('[data-open="true"]') ||
        wrapper.querySelector('[data-open="true"]')
    );
  }

  function syncOpenState() {
    var isOpen = isFormOpen();

    if (isOpen && !formWasOpen) {
      formWasOpen = true;
      formStarted = false;
      submitTracked = false;
      trackStep('form-open');
      return;
    }

    if (!isOpen && formWasOpen) {
      formWasOpen = false;
      restoreProductPageview();
    }
  }

  function watchWrapper(element) {
    if (!element || element === wrapper) return;

    wrapper = element;

    if (wrapperObserver) wrapperObserver.disconnect();

    wrapperObserver = new MutationObserver(syncOpenState);
    wrapperObserver.observe(wrapper, {
      attributes: true,
      attributeFilter: ['data-open', 'aria-hidden', 'class', 'style'],
      childList: true,
      subtree: true
    });

    syncOpenState();
  }

  function findWrapper() {
    watchWrapper(document.getElementById(wrapperId));
  }

  function isInsideOpenForm(target) {
    return (
      formWasOpen &&
      wrapper &&
      target instanceof Element &&
      wrapper.contains(target)
    );
  }

  function trackFormStart(event) {
    if (
      formStarted ||
      !event.isTrusted ||
      !isInsideOpenForm(event.target) ||
      !event.target.matches(fieldSelector)
    ) {
      return;
    }

    formStarted = true;
    trackStep('form-start');
  }

  function trackSubmitAttempt(event) {
    if (
      submitTracked ||
      !event.isTrusted ||
      !isInsideOpenForm(event.target) ||
      !event.target.closest(submitSelector)
    ) {
      return;
    }

    submitTracked = true;
    trackStep('submit-attempt');
  }

  function trackNativeSubmit(event) {
    if (
      submitTracked ||
      !event.isTrusted ||
      !isInsideOpenForm(event.target)
    ) {
      return;
    }

    submitTracked = true;
    trackStep('submit-attempt');
  }

  document.addEventListener('input', trackFormStart, true);
  document.addEventListener('change', trackFormStart, true);
  document.addEventListener('click', trackSubmitAttempt, true);
  document.addEventListener('submit', trackNativeSubmit, true);

  var discoveryObserver = new MutationObserver(function () {
    if (wrapper && !wrapper.isConnected) {
      if (wrapperObserver) wrapperObserver.disconnect();
      wrapper = null;

      if (formWasOpen) {
        formWasOpen = false;
        restoreProductPageview();
      }
    }

    if (!wrapper) findWrapper();
  });

  discoveryObserver.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });

  findWrapper();
})();